import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import React from "react";
import {
  getColorStatusCashback,
  getLabelStatusCashback,
  getStatusCashback,
  getTitleStatusCashback,
} from "./cashback-utils";
import { Body1, H6, Icone } from "../../../components";

const STR = {
  title: "Legenda Cashback",
  subtitle: "Legenda dos status de cada cashback",
};

function CashbackLegend() {
  const status = ["C", "E", "U", "V"].map((ele, idx) => ({
    label: getLabelStatusCashback(ele),
    title: getTitleStatusCashback(ele),
    color: getColorStatusCashback(ele),
    icon: getStatusCashback(ele),
  }));
  return (
    <Stack>
      <H6>{STR.title}</H6>
      <Body1 align="center">{STR.subtitle}</Body1>
      <List>
        {status.map((ele, idx) => (
          <ListItem key={idx}>
            <ListItemIcon>
              <Icone icone={ele.icon} color={ele.color} />
            </ListItemIcon>

            <ListItemText primary={ele.label} secondary={ele.title} />
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}

export default CashbackLegend;
